import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { JahresbeitragChanged } from '@ps20-frontend/frontend-models';

export const jahresbeitragReducer = function (sectionState = 0, action: AnyAction): number {
  if (action.type === GlobalActions.JAHREBEITRAG_CHANGED) {
    const actionPayload: JahresbeitragChanged = action.payload;
    return actionPayload.jahresbeitrag;
  }
  return sectionState;
};
